import { render } from "./fileMenu.vue?vue&type=template&id=a9035bf8&scoped=true&bindings={\"isOpen\":\"props\",\"data\":\"props\",\"atTitle\":\"props\",\"slotIsEmpty\":\"options\",\"label\":\"options\",\"savedGamesExcludingZero\":\"options\",\"clickEmit\":\"options\"}"
import script from "./fileMenu.vue?vue&type=script&lang=js"
export * from "./fileMenu.vue?vue&type=script&lang=js"

import "./fileMenu.vue?vue&type=style&index=0&id=a9035bf8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a9035bf8"

export default script